import { makeStyles } from "@material-ui/core";

export const washCountCardStyle = makeStyles((theme) => ({

}));